module.exports = __webpack_public_path__ + "static/media/Milex-Cube-Pessary-Instructions-for-Use@2x.bae1c0c9.jpg";